<template>
  <div class="matriculas-table-wrapper">
    <v-card elevation="2">
      <v-card-title class="table-header white--text">
        <v-icon color="white" class="mr-2">mdi-table</v-icon>
        Selecione a Matrícula para Importar
      </v-card-title>

      <v-alert type="warning" colored-border border="left" elevation="1" class="ma-4 mb-0">
        <div>
          <strong class="d-block mb-1">
            Foram encontradas {{ matriculas.length }}
            {{ matriculas.length === 1 ? "matrícula anterior" : "matrículas anteriores" }}
          </strong>
          <span class="body-2">
            Clique em uma linha para selecionar a matrícula de onde deseja importar notas e faltas
          </span>
        </div>
      </v-alert>

      <v-card-text class="pa-0">
        <v-simple-table class="matriculas-table">
          <template v-slot:default>
            <thead>
              <tr>
                <th width="60px"></th>
                <th>ID</th>
                <th>Aluno</th>
                <th>Turma</th>
                <th>Série</th>
                <th class="text-center">Situação</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in matriculas"
                :key="item.id"
                :class="['selectable-row', { 'selected-row': isSelected(item) }]"
                @click="selecionarMatricula(item)"
              >
                <td>
                  <v-icon color="success">
                    {{ isSelected(item) ? "mdi-check-circle" : "mdi-circle-outline" }}
                  </v-icon>
                </td>
                <td>
                  <v-chip small color="grey lighten-3">
                    <v-icon small left>mdi-pound</v-icon>
                    {{ item.id }}
                  </v-chip>
                </td>
                <td>
                  <div class="d-flex align-center">
                    <v-icon small class="mr-2" color="primary">mdi-account</v-icon>
                    <span class="font-weight-medium">{{ item.aluno.nomecompleto }}</span>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-center">
                    <v-icon small class="mr-2" color="blue">mdi-google-classroom</v-icon>
                    {{ item.turma.descricao }}
                  </div>
                </td>
                <td>
                  <div class="d-flex align-center">
                    <v-icon small class="mr-2" color="purple">mdi-book-open-variant</v-icon>
                    {{
                      item.turma.series && item.turma.series.length > 0
                        ? item.turma.series[0].descricao
                        : "-"
                    }}
                  </div>
                </td>
                <td class="text-center">
                  <v-chip small color="grey" dark>
                    {{ item.situacao }}
                  </v-chip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>

      <v-divider></v-divider>

      <v-alert v-if="validated" type="error" outlined class="ma-4">
        Você precisa selecionar uma matrícula para continuar.
      </v-alert>

      <v-card-actions class="pa-4">
        <div v-if="value" class="d-flex align-center">
          <v-icon color="success" class="mr-2">mdi-check-circle</v-icon>
          <span class="body-2 font-weight-medium"> Matrícula selecionada: #{{ value }} </span>
        </div>
        <div v-else class="body-2 grey--text">Nenhuma matrícula selecionada</div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "EMatriculasTableSelect",
  props: {
    matriculas: {
      type: Array,
      required: true,
      default: () => [],
    },
    value: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      validated: false,
    };
  },
  methods: {
    selecionarMatricula(item) {
      this.validated = false;
      const novoValor = this.isSelected(item) ? null : item.id;
      this.$emit("input", novoValor);
    },
    isSelected(item) {
      return this.value === item.id;
    },

    validate() {
      if (!this.value) {
        this.validated = true;
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.matriculas-table-wrapper {
  width: 100%;
}

.table-header {
  background: linear-gradient(135deg, #fb9716 0%, #f57c00 100%);
  font-size: 18px;
  font-weight: 600;
}

.selectable-row {
  cursor: pointer;
  transition: all 0.2s ease;
}

.selectable-row:hover {
  background-color: #f5f5f5 !important;
}

.selected-row {
  background-color: #e8f5e9 !important;
}

.selected-row:hover {
  background-color: #c8e6c9 !important;
}

.matriculas-table thead th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #424242;
}
</style>
